import {Component, Input} from '@angular/core';
import {StateService} from "@uirouter/core";

import {
    ParametersService,
    SubtitlesService,
    ViewsService,
    ZonesService
} from "../../core";
import {SystemContainerViewWithId} from "../../models";


@Component({
    selector: 'zones-container-tile',
    templateUrl: './zones-container-tile.component.html',
    styleUrls: ['./zones-container-tile.component.scss']
})
export class ZonesContainerTileComponent {
    @Input() container: SystemContainerViewWithId;

    constructor(
        private parameters: ParametersService,
        private subtitles: SubtitlesService,
        private $state: StateService,
        public views: ViewsService,
        public zones: ZonesService,
    ) {

    }

    getTypeSubtitle(): string {
        return this.container.data.textId !== 0
            ? this.subtitle(this.container.data.textId)
            : '';
    }

    subtitle(value: number): string {
        return this.subtitles.setSubtitle(value);
    }

    setTemplate(): void{
        this.zones.selectContainer(this.container.data);
        this.$state.go('zone_container_info_with_template',
            {selectedModuleHash: this.parameters.selectedModuleHash});
    }
}
